import { Component } from "react";
import type { ReactNode } from "react";

interface ErrorBoundaryProps {
  readonly children: ReactNode;
  readonly onUseFallback: () => void;
  readonly fallbackDescription?: string;
}

interface ErrorBoundaryState {
  readonly failed: boolean;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  public override state: ErrorBoundaryState = { failed: false };

  public static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true };
  }

  public override render() {
    if (!this.state.failed) {
      return this.props.children;
    }

    return (
      <section className="scene-recovery" aria-labelledby="scene-error-title">
        <div>
          <p className="eyebrow">Teaching view recovery</p>
          <h2 id="scene-error-title">The 3D view could not start</h2>
          <p>
            {this.props.fallbackDescription ??
              "Continue with the same Moon phase geometry in the interactive 2D teaching view."}
          </p>
          <button type="button" onClick={this.props.onUseFallback}>
            Use the 2D teaching view
          </button>
        </div>
      </section>
    );
  }
}
